import Vue from 'vue'
import Cookie from 'js-cookie'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Main from '../views/Main.vue'
import Login from '../views/Login.vue'


import Admin from '../views/user/Admin.vue'
import Role from '../views/user/Role.vue'
import Authority from '../views/user/Authority.vue'

import Recharge from '../views/recharge/Recharge.vue'
import Grechargeall from '../views/recharge/Grecharge.vue'
import Log from '../views/recharge/Log.vue'
import Adjust from '../views/recharge/Adjust.vue'
import Moneyorder from '../views/recharge/Moneyorder.vue'

import Runningwater from '../views/board/Runningwater.vue'
import Income from '../views/board/Income.vue'
import Pay from '../views/board/Pay.vue'
import Rechargeall from '../views/board/Rechargeall.vue'
import Rwlist from '../views/board/Rwlist.vue'
import Commision from '../views/board/Commision.vue'
import Entrust from '../views/board/Entrust.vue'
import Paylook from '../views/board/Paylook.vue'
import Reward from '../views/board/Reward.vue'
import Exhibition from '../views/board/Exhibition.vue'

import Ericaall from '../views/erica/All.vue'
import Ericawde from '../views/erica/Wde.vue'
import Ericawdetail from '../views/erica/Wdetail.vue'
//广告
import Advertisement from '../views/board/Advertisement.vue'
//版权
import Copyright from '../views/board/Copyright.vue'
//欧吸
import Ouxi from '../views/board/Ouxi.vue'
//import Dealer from '../views/board/Ouxi.vue'
//通贩
import Dealer from '../views/board/Dealer.vue'

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
const routes = [
		{ path: '/', component: Main,redirect:'/home',name:'main',
		 children: [
		         { path: 'home',name:'home', component: Home }, //首页
		         { path: 'admin', name:'admin',component: Admin }, //管理员列表
				 { path: 'role', name:'role',component: Role }, //角色设计
				 { path: 'authority',name:'authority', component: Authority }, //权限设置
				 { path: 'recharge', name:'recharge',component: Recharge },	//个人提现申请
				 { path: 'grecharge', name:'grecharge',component: Grechargeall },	//提现申请
				 { path: 'log', name:'log',component: Log },	//日志列表
				 { path: 'adjust', name:'adjust',component: Adjust },	//调整列表
				 { path: 'moneyorder', name:'moneyorder',component: Moneyorder },	//图力值订单管理
				 { path: 'runningwater', name:'runningwater',component: Runningwater },	//流水统计
				 { path: 'income', name:'income',component: Income },	//收入统计
				 { path: 'rechargeall', name:'rechargeall',component: Rechargeall },	//支出统计
				 { path: 'pay', name:'pay',component: Pay }, 	//提现统计
				 { path: 'rwlist', name:'rwlist',component: Rwlist }, 	//提现统计
				 { path: 'commision', name:'commision',component: Commision }, 	//提现统计
				 { path: 'entrust', name:'entrust',component: Entrust }, 	//提现统计
				 { path: 'paylook', name:'paylook',component: Paylook }, 	//提现统计
				 { path: 'reward', name:'reward',component: Reward }, 	//提现统计
				 { path: 'exhibition', name:'exhibition',component: Exhibition }, 	//漫展
				 
		       
				 { path: 'ericaall', name:'ericaall',component: Ericaall }, 	//平台收支账单
				 { path: 'ericawde', name:'ericawde',component: Ericawde }, 	//提现统计
				 { path: 'ericawdetail', name:'ericawdetail',component: Ericawdetail }, 	//提现统计
				
				 { path: 'advertisement', name:'advertisement',component: Advertisement }, 	//广告
				 { path: 'copyright', name:'copyright',component: Copyright }, 	//版权
				 { path: 'ouxi', name:'ouxi',component: Ouxi }, 	//欧吸
				 { path: 'dealer', name:'dealer',component: Dealer }, 	//欧吸
				   
				]},
		{ path: '/login',name:'login', component: Login }
		
]

const router = new VueRouter({
  routes // (缩写) 相当于 routes: routes
})

router.beforeEach((to,from,next)=>{
	const token = Cookie.get('token')
	if(!token && to.name !== 'login' ){
		next({name:'login'})
	}else if(token && to.name ==='login'){
		next({name:'home'})
	}else{
		next()
	}
})

export default router
